import { shortAgeNumber } from "../helpers/numbers";

const age_array = [3, 5, 10, 15, 20, 30];

export const getAgeStates =() => {
    let options = [
        {value: '', label: 'مهم نیست', checked: false}
    ];

    age_array.map((age) => {
        const shortMoney = shortAgeNumber(age);
        options.push({value: age, label: shortMoney.num + ' ' + shortMoney.unit, checked: false})
    });

    return {
        show: false,
        options: options,
        selected_range: {
            min: null,
            max: null
        }
    }
};

